/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './pageMetadata';
import { ShipDTO } from './shipDTO';


export interface PagedModelShipDTO { 
    content?: Array<ShipDTO>;
    page?: PageMetadata;
}

